"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cervaro": {
    "864533f9": [{
      "hkey": "8a418e6e",
      "slug": "sordella",
      "name": "Sordella",
      "primary": true,
      "skipSearch": false
    }],
    "isola-tocca": [{
      "hkey": "8a418e6e",
      "slug": "sordella",
      "name": "Sordella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8d1f54d2": [{
      "hkey": "77671e0f",
      "slug": "pastenelle-pacitti-sprumaro",
      "name": "Pastenelle-Pacitti-Sprumaro",
      "primary": true,
      "skipSearch": false
    }],
    "pastenelle": [{
      "hkey": "77671e0f",
      "slug": "pastenelle-pacitti-sprumaro",
      "name": "Pastenelle-Pacitti-Sprumaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;